import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=52cb768f&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52cb768f')) {
      api.createRecord('52cb768f', component.options)
    } else {
      api.reload('52cb768f', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=52cb768f&", function () {
      api.rerender('52cb768f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2pObP9khw6lOP/JS/comp/FavElement.vue"
export default component.exports